<template>
    <div id="content">
        <div class="container">
            <div id="page-header-fixed" class="mb-20">
                <div class="container">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <a @click="$router.back()">
                                    <img src="/themes/ito/images/back-to.svg" alt="">
                                </a>
                            </li>
                            <li class="active">
                                {{ unit_name.trim().toLowerCase() === lesson_name.trim().toLowerCase() ? lesson_name : `${unit_name} - ${lesson_name}` }}: {{ title_lesson }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mark-lesson" v-if="screen != 'list'"></div>
            <div class="card" :class="screen != 'list' ? 'box-leson' : ''" style="overflow: inherit; background: transparent; box-shadow: none;border: none;">
                <div class="list-extension" v-if="screen == 'list'">
                    <div class="extension-item" v-for="(item, index) in items" :key="index">
                        <div class="extension-content">
                            <div class="extension-content-title">{{ item.name }}</div>
                        </div>
                        <div class="d-flex align-items-center gap-3">
                            <div class="extension-status">
                                <i :class="item.complete == 1 ? 'ito-icon-checked' : 'ito-icon-checked-disable'"></i>
                            </div>
                            <div class="extension-action">
                                <button class="btn btn-default" @click="detailLessonOpen(item.id, item.type)">{{
                                    $t('discover') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'vocabulary'">
                    <div class="lesson-action-button" @click="quitPracticeNotCf"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe ref="extensionFrame" :src="item.content" frameborder="0" allowfullscreen width="100%"
                            height="100%" allow="microphone; camera; autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share"></iframe>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'lecture'" style="background: #fff;">
                    <div class="lesson-action-button" @click="quitPracticeNotCf"><span>+</span></div>
                    <h5 class="card-title">
                        <span class="title">Lecture</span>
                    </h5>
                    <div class="card-content" style="height: calc(100% - 52px); padding: 0;">
                        <iframe ref="extensionFrame" width="100%" height="100%" :src="item.content" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'practice'">
                    <div class="lesson-action-button" @click="quitPractice"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe ref="extensionFrame" :src="item.content" frameborder="0" allowfullscreen width="100%"
                            height="100%" scrolling="no"></iframe>

                    </div>
                </div>
                <div class="card-body" v-if="screen == 'handouts'">
                    <div class="lesson-action-button" @click="quitPracticeNotCf"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe ref="extensionFrame" :src="item.content" frameborder="0" allowfullscreen width="100%"
                            height="100%" scrolling="no"></iframe>

                    </div>
                </div>
                <div class="card-body" v-if="screen == 'story'">
                    <div class="lesson-action-button" @click="quitPracticeNotCf"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe ref="extensionFrame" :src="item.content" frameborder="0" allowfullscreen width="100%"
                            height="100%"></iframe>
                    </div>
                </div>
            </div>
            <div class="modal fade reward-popup" id="rewardPopup" tabindex="-1" role="dialog" aria-labelledby="rewardPopup"
                aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 330px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <div class="close-popup" data-bs-dismiss="modal" @click="gotoWave"></div>
                        <h3 class="popup-title success">Completed practice</h3>
                        <div class="list-item-result-popup">
                            <div class="item-result-popup" :class="crown > 0 ? 'active' : ''"></div>
                            <div class="item-result-popup" :class="crown > 1 ? 'active' : ''"></div>
                            <div class="item-result-popup" :class="crown > 2 ? 'active' : ''"></div>
                        </div>
                        <div class="box-result-popup">
                            <div class="result-txt">You answered correctly</div>
                            <div class="result-score"><span class="score">{{ correct }}</span>/<span class="total">{{ total
                            }}</span> questions</div>
                        </div>
                        <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem"
                            data-bs-dismiss="modal" aria-label="Close">{{ (next != '' && next != undefined) ? 'Go to ' +
                                next.name : 'Close' }}</button>
                    </div>
                </div>
            </div>
            <div class="modal fade reward-popup" id="rewardQuiz" tabindex="-1" role="dialog" aria-labelledby="rewardQuiz"
                aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 330px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <i class="ito-icon-close modal-close" data-bs-dismiss="modal" aria-label="Close" @click="quitPracticeNotCf()"></i>
                        <h3 class="popup-title success">Completed fact reading</h3>

                        <div class="box-result-popup">
                            <div class="result-txt">You answered correctly</div>
                            <div class="result-score"><span class="score">{{ correct }}</span>/<span class="total">{{ total
                            }}</span> </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modalVocabSuccess" class="modal fade modal-flex" tabindex="-1" role="dialog"
                style="text-align: center">
                <div class="modal-dialog modal-sm" role="document">
                    <div class="modal-content">
                        <i class="ito-icon-close modal-close" data-bs-dismiss="modal" aria-label="Close"></i>
                        <div class="modal-body">
                            <h4 class="title">{{ $t('congratulations') }}</h4>

                            <img src="/themes/ito/images/get-rewarded.svg" alt="">
                            <p class="mt-2">{{ $t('you_have_completed_your_vocabulary') }}</p>
                            <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem"
                                data-bs-dismiss="modal" aria-label="Close">{{ (next != '' && next != undefined) ? 'Go to ' +
                                    next.name : 'Close' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <extension-result-dialog ref="extensionResultDialog"></extension-result-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { getUnitLessonDetail, getUnitLessonItem, getItemInfo } from "../../models/dashboard";
import { getConfigs } from "../../utils/utils";
import { ConfirmDialogue, ExtensionResultDialog } from "../modal";


export default {
    name: "ExtensionDetail",
    components: { ConfirmDialogue, ExtensionResultDialog },
    title: 'Extension detail',
    props: [
        'user_info'
    ],
    data() {
        const programData = localStorage.getItem('program');
        const configs = getConfigs();
        const programs = configs.programs;
        var program = {}
        programs.forEach(p => {
            if (p.code == programData) {
                program = p;
            }
        });

        return {
            isLoading: false,
            items: [],
            unit_id: this.$route.params.unit_id,
            lesson_id: this.$route.params.lesson_id,
            unit_name: '',
            lesson_name: '',
            title_lesson: '',
            item: {},
            screen: 'list',
            correct: 0,
            total: 0,
            crown: 0,
            current_item: 0,
            next: '',
            program: program,
        };
    },

    created() {
        this.getUnitLessonDetail()
        if (this.item) {
            const f = function (event) {
                switch (event.data.type) {
                    case 'update_item_info':
                        getItemInfo({
                            id: this.item?.id,
                            item_type: this.item?.type,
                            program: this.program.code
                        });
                }
                window.removeEventListener("message", f, false);
            }
            window.addEventListener("message", f);
        }
    },
    mounted() {
        window.addEventListener('message', this.handleMessage)
        window.addEventListener('message', this.handleUpgradeFeature);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage)
        window.removeEventListener('message', this.handleUpgradeFeature);
    },
    watch: {
        'item': function (newVal, oldVal) {
            if (newVal) {
                const that = this;
                let index = this.items.findIndex(x => x.id == newVal.id);
                that.current_item = index;
                let array_next = [];
                for (let i = 0; i < that.items.length; i++) {
                    if (i < that.current_item && that.items[i].complete == 0) {
                        array_next.push(i);
                    }
                    that.next = that.items[array_next[0]];
                    if (i > that.current_item) {
                        if (that.items[i].complete == 0) {
                            that.next = that.items[i];
                            break;
                        } else {
                            if (array_next[0]) {
                                that.next = that.items[array_next[0]];
                                break;
                            }
                            else {
                                that.next = '';
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {
        getUnitLessonDetail() {
            const that = this;
            const { subject_id, unit_id, lesson_id } = that.$route.params;
            that.isLoading = true;

            axios.all([
                getUnitLessonDetail(subject_id, unit_id, lesson_id),
            ]).then(axios.spread((response) => {
                that.isLoading = false;
                if (response.data.code != 0) {
                    return;
                }
                that.items = response.data.results.item;
                that.unit_name = response.data.results.name_unit;
                that.lesson_name = response.data.results.name_lesson;
                that.title_lesson = response.data.results.title_lesson;
            }));
        },

        nextItem() {
            let id = this.next.id;
            const that = this;
            that.isLoading = true;

            axios.all([
                getUnitLessonItem(id),
            ]).then(axios.spread((response) => {
                that.isLoading = false;
                if (response.data.code != 0) {
                    return;
                }
                that.item = response.data.results.item;
                that.unit_name = response.data.results.name_unit;
                that.lesson_name = response.data.results.name_lesson;
                that.title_lesson = response.data.results.title_lesson;
                that.screen = response.data.results.item.type;
            }));
        },

        handleMessage(event) {
            if (this.item) {
                switch (event.data.type) {
                    case 'fact_reading_quiz_done':
                        this.correct = event.data.correct;
                        this.total = event.data.total;
                        $('#rewardQuiz').modal('show');
                        break;
                    case 'update_item_info':
                        axios.all([
                            getItemInfo({
                                id: this.item.id,
                                item_type: this.item.type,
                                program: this.program.code
                            }),
                        ]).then(axios.spread((response) => {
                            if (response.data.code != 0) {
                                return;
                            }
                            if (this.item.type == 'practice') {
                                this.correct = response.data.results.current_result.correct_quest;
                                this.total = response.data.results.current_result.total_quest;
                                this.crown = response.data.results.current_result.crown;
                                $('#rewardPopup').modal('show');
                            }
                            if (this.item.type == 'vocabulary') {
                                $('#modalVocabSuccess').modal('show');
                            }
                            this.getUnitLessonDetail();
                        }));
                        break;
                    case 'extension_done':
                        this.finishPractice(event.data.result)
                        break;
                }
            }
        },
        handleUpgradeFeature(event) {
            if (event.data === 'upgrade_ai_speak') {
                this.$router.push(`/upgrade-feature?feature_code=speak_ai_attempt`);
            }
            if (event.data === 'upgrade_package') {
                this.$router.push(`/upgrade-account`);
            }
        },
        sendMessage(action) {
            this.$refs.extensionFrame.contentWindow.postMessage({
                "action": action,
            }, '*');
        },

        async showDialog(dialog, params) {
            const cfm = await dialog.show(params);
            return cfm;
        },

        quitPractice() {
            const dialog = this.$refs.confirmDialogue
            const params = {
                title: this.$t('confirm_close'),
                message: this.$t('confirm_close_content'),
                okButton: this.$t('quit'),
            }
            this.showDialog(dialog, params).then((confirm) => {
                if (confirm) {
                    this.screen = 'list';
                    this.$store.commit("setShowEffect", true);

                    getItemInfo({
                        id: this.item.id,
                        item_type: this.item.type,
                        program: this.program.code
                    });
                    this.getUnitLessonDetail()
                }
            })

        },
        quitPracticeNotCf() {
            this.screen = 'list';
            getItemInfo({
                id: this.item.id,
                item_type: this.item.type,
                program: this.program.code
            });
            this.getUnitLessonDetail()
        },

        finishPractice(result) {
            if (result && result.completed == 1) {
                const dialog = this.$refs.extensionResultDialog
                var nextPractice = undefined
                if (this.next != '' && this.next != undefined) {
                    nextPractice = this.$t('next_practice')
                    console.log(this.next);
                }
                const params = {
                    title: this.$t('practice_result'),
                    message: result,
                    cancelButton: this.$t('redo_practice'),
                    okButton: nextPractice,
                }
                getItemInfo({
                    id: this.item.id,
                    item_type: this.item.type,
                    program: this.program.code
                });
                this.showDialog(dialog, params).then((confirm) => {
                    if (confirm) {
                        this.nextItem()
                    }
                    else {
                        this.detailLessonOpen(this.item.id, this.item.type)
                    }
                })
            }
        },

        gotoWave() {
            this.screen = 'list';
            this.$store.commit("setShowEffect", true);

            getItemInfo({
                id: this.item.id,
                item_type: this.item.type,
                program: this.program.code
            });
            this.getUnitLessonDetail()
            this.$forceUpdate()
        },


        detailLessonOpen(id, type) {
            const that = this;
            that.$store.commit("setShowEffect", false);
            that.isLoading = true;

            axios.all([
                getUnitLessonItem(id, this.program.code),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.item = response.data.results.item;
                that.unit_name = response.data.results.name_unit;
                that.lesson_name = response.data.results.name_lesson;
                that.screen = response.data.results.item.type;
            }));
        }
    }
}
</script>

<style scoped>
#page-header .breadcrumb {
    margin-bottom: 0;
}

.lesson-action-button {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 7px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    background: #F04821;
    cursor: pointer
}

.lesson-action-button span {
    display: block;
    width: 26px;
    height: 26px;
    margin: 13px auto;
    background: #ffffff;
    text-align: center;
    color: #f04821;
    font-size: 26px;
    line-height: 26px;
    font-weight: bold;
    border-radius: 100%;
    transform: rotate(45deg);
}

.mark-lesson {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    left: 0;
    right: 0;
    top: 0;
    z-index: 1000;
}

.modal-sm {
    max-width: 400px;
}

.ito-icon-close {
    position: absolute;
    right: 18px;
}

.next-item-modal {
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    border-radius: 20px;
    box-shadow: 4px 4px 0px 0px #00000012;
    border: none;
    padding: 5px 10px;
    color: #fff;
    margin-top: 10px;
}

.box-result-popup {
    padding: 7px 15px;
}

.list-extension {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.extension-item {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 0px 0px #E7E7E740 inset;
    box-shadow: 4px 4px 0px 0px #00000012;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.extension-action .btn-default {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
    box-shadow: inset 0px 2px 0px rgb(255 255 255 / 20%);
    border-radius: 30px;
    filter: drop-shadow(4px 4px 0px rgba(0, 0, 0, 0.07));
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    padding: 8px 25px;
    white-space: nowrap;

}

.btn-default:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;

}

.extension-content-title {
    color: #000;
    font-size: 14px;
    font-weight: 700;
}


.extension-content {
    width: 100%;
}

.box-leson {
    position: fixed;
    width: 98%;
    height: 96vh;
    background: #fff;
    left: 1%;
    top: 2vh;
    z-index: 1001;
}
</style>